import PropTypes from 'prop-types'
import React from 'react'
import { Field } from 'react-final-form'

import Select2Inner from './Select2Inner'

const Select2 = props => {
  const { name, ...remainingProps } = props

  return <Field {...remainingProps} name={name} component={Select2Inner} />
}

Select2.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
}

Select2.defaultProps = {}

export default Select2
